module.exports = __webpack_public_path__ + "static/media/complete_shooting_gallery_1.dad1c331.mp3";